import { Box, Icon, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import MaterialReactTable, { MRT_Cell, MRT_ColumnDef, MRT_DensityState, MRT_ExpandedState, MRT_GroupingState, MRT_PaginationState, MRT_Row, MRT_RowSelectionState, MRT_SortingState, MRT_TableInstance } from "material-react-table";
import { Dispatch, ReactNode, SetStateAction, useEffect, useState } from "react";
import { IFilteringViewModel, ITableData } from "../../_common/interface/table";
import { ORANGE_COLOR } from "../../_const/color.const";
import { TABLE_FILTER } from "../../_const/tableFilter.const";

export function CommonTable(params: {
    isLoading?: boolean,
    columns: MRT_ColumnDef<any>[],
    data: ITableData<any>,
    onEdit?(id: number | null): void,
    onView?(item: any | null): void,
    onDelete?(id: number | null): void,
    onEditUser?(id: string | null): void,
    onRenderReport?(id: number | null): void,
    onRowClick?(id: number | null): void,
    actions?: (props: {
        cell: MRT_Cell<any>;
        row: MRT_Row<any>;
        table: MRT_TableInstance<any>;
    }) => ReactNode,
    filter?: IFilteringViewModel | null,
    height?: number,
    width?: string,
    setFilter?: Dispatch<SetStateAction<IFilteringViewModel>>,
    selectedRowId?: number,
    selectedRows?: MRT_RowSelectionState,
    setSelectedRow?(b: any): void,
    setSelectedRows2?(b: MRT_RowSelectionState, c?: MRT_RowSelectionState): void,
    setSelectedRows?(b: Array<number>): void
    enableMultiRowSelection?: boolean,
    enableRowSelection?: boolean,
    enableGrouping?: boolean,
    enableSorting?: boolean,
    enableMultiSort?: boolean,
    enableColumnActions?: boolean,
    isMultiSortEvent?: ((e: unknown) => boolean) | undefined,
    enableColumnFilterModes?: boolean
    name?: string,
    type?: string,
    tableHeader?: string,
    headerHasButton?: boolean,
    headerButtonName?: string,
    headerButtonType?: 'select' | 'view' | 'create' | 'update' | 'delete' | 'add',
    headerButtonIcon?: string,
    headerButtonDisabled?: boolean,
    headerButtonOnClick?: any,
    headerHasInputField?: boolean,
    headerInputLabel?: string,
    headerInputDisabled?: boolean,
    headerInputValue?: number | string | null,
    headerInputPlaceholder?: string,
    headerInputName?: string,
    headerInputHandleChange?: any,
    columnVisibility?: {},
    customNoRecordsMessage?: string,
    density?: MRT_DensityState,
    expanded?: MRT_ExpandedState,
    grouping?: MRT_GroupingState,
    sorting?: MRT_SortingState,
    enableSelectAll?: boolean,

    pageSize?: number,
}) {

    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: params.filter?.pageIndex || TABLE_FILTER.pageIndex || 0,
        pageSize: params.filter?.pageSize || params?.pageSize || TABLE_FILTER.pageSize || 10,
    });

    const [sorting, setSorting] = useState<MRT_SortingState>(params.sorting || []);
    const [selectedRowId, setSelectedRowId] = useState(params.selectedRowId || 0);
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
    const [init, setInit] = useState(true);

    useEffect(() => {
        if (
            params.filter?.pageIndex === pagination.pageIndex &&
            (params.filter?.pageSize || params.pageSize) === pagination.pageSize &&
            (params.filter?.order) === ((sorting.length && sorting[0].desc) ? "desc" : "asc") &&
            (params.filter?.orderBy) === (sorting.length ? sorting[0].id : '')
        ) {
            return;
        }

        let _filter = {
            ...params.filter,
            search: "",
            pageIndex: pagination.pageIndex,
            pageSize: pagination.pageSize,
            order: sorting.length && sorting[0].desc ? "desc" : "asc",
            orderBy: sorting.length ? sorting[0].id : '',
        } as IFilteringViewModel;

        if (params.setFilter)
            params.setFilter(_filter);

    }, [pagination, sorting]);

    useEffect(() => {
        console.log("refresh");
    });

    useEffect(() => {
        if (params.selectedRows) {
            setRowSelection(params.selectedRows);
        }
    }, [params.selectedRows]);

    return (
        <>
            <MaterialReactTable
                data={params.data.items}
                columns={params.columns}
                rowCount={params.data.count}
                muiTablePaginationProps={{ rowsPerPageOptions: [10, 20, 50, 100, 1000] }}
                enableFilters={false}
                onSortingChange={setSorting}
                enableSelectAll={params.enableSelectAll === false ? false : true}
                manualPagination
                manualFiltering
                autoResetAll={false}
                manualSorting
                enableColumnActions={params.enableColumnActions}
                enableColumnFilterModes={params.enableColumnFilterModes}
                getRowId={(row) => row.id}
                onRowSelectionChange={(a: any) => { if (params.setSelectedRows2) { params.setSelectedRows2(a) } }}
                enableMultiRowSelection={params.enableMultiRowSelection}
                enableRowSelection={params.enableRowSelection}
                enableGrouping={params.enableGrouping}
                enableSorting={params.enableSorting}
                enableMultiSort={params.enableMultiSort}
                isMultiSortEvent={params.isMultiSortEvent}
                enableRowActions={(params.onEdit || params.onEditUser || params.onView || params.onDelete || params.onRenderReport) ? true : false}
                renderTopToolbarCustomActions={() => (
                    <>
                        <Box display="flex" width="100%" gap={10} justifyContent='flex-start' alignItems="center">
                            <Box alignSelf="center">
                                <Typography variant="h5" sx={{ fontFamily: 'Open Sans', marginLeft: '8px' }}>{params.tableHeader ? params.tableHeader : ""}</Typography>
                            </Box>
                            <Box display="flex" gap={5}>
                                {params.headerHasInputField && (
                                    <>
                                        <Box bgcolor="white" borderRadius="5px" justifyItems="center">
                                            <TextField
                                                size="small"
                                                label={params.headerInputLabel ? params.headerInputLabel : ''}
                                                disabled={params.headerInputDisabled}
                                                name={params.headerInputName ? params.headerInputName : ''}
                                                value={params.headerInputValue ? params.headerInputValue : null}
                                                onChange={params.headerInputHandleChange}
                                                placeholder={params.headerInputPlaceholder ? params.headerInputPlaceholder : ''}
                                                variant="outlined" />
                                        </Box>
                                    </>
                                )}

                            </Box>
                        </Box>
                    </>

                )}
                renderRowActions={params.actions ? params.actions : ({ row, table }) =>
                    (!!params.onEdit || !!params.onEditUser || !!params.onView || !!params.onDelete) ? (
                        <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                            <>
                                {(params.onEdit || params.onEditUser) &&
                                    <Tooltip title="Edit">
                                        <IconButton
                                            color="primary"
                                            onClick={() => { return (params.onEdit ? params.onEdit((row.original as any).id || null) : null) || (params.onEditUser ? params.onEditUser((row.original as any).id || null) : null) }}
                                        >
                                            <Icon>edit</Icon>
                                        </IconButton>
                                    </Tooltip>
                                }

                                {(params.onDelete) &&
                                    <Tooltip title="Delete">
                                        <IconButton
                                            color="secondary"
                                            onClick={() => { return (params.onDelete ? params.onDelete((row.original as any).id || null) : null) }}
                                        >
                                            <Icon>clear</Icon>
                                        </IconButton>
                                    </Tooltip>
                                }

                                {(params.onRenderReport) &&
                                    <Tooltip title="View Report">
                                        <IconButton
                                            color="primary"
                                            onClick={() => { return (params.onRenderReport ? params.onRenderReport((row.original as any).id || null) : null) }}
                                        >
                                            <Icon>assessment</Icon>
                                        </IconButton>
                                    </Tooltip>
                                }

                                {(params.onView) &&
                                    <Tooltip title="View User">
                                        <IconButton
                                            color="primary"
                                            onClick={() => { return (params.onView ? params.onView((row.original as any) || null) : null) }}
                                        >
                                            <Icon>visibility</Icon>
                                        </IconButton>
                                    </Tooltip>
                                }
                            </>
                        </Box >
                    ) : <></>
                }
                initialState={{
                    density: params.density,
                    expanded: params.expanded, //expand all groups by default
                    grouping: params.grouping, //an array of columns to group by by default (can be multiple)
                    sorting: params.sorting
                }}
                state={{

                    sorting,
                    pagination,
                    showGlobalFilter: false,
                    showColumnFilters: false,
                    isLoading: params.isLoading || false,
                    showProgressBars: params.isLoading || false,
                    rowSelection,
                    columnVisibility: params.columnVisibility || {},
                }}
                localization={{
                    noRecordsToDisplay: params.customNoRecordsMessage ? params.customNoRecordsMessage : 'No records to display'
                }}
                muiLinearProgressProps={{
                    sx: {
                        backgroundColor: 'transparent', '& .MuiLinearProgress-bar': {
                            backgroundColor: 'transparent !important'
                        },
                    },
                    variant: "indeterminate",
                }}
                enableStickyHeader
                muiTableContainerProps={{ sx: { maxHeight: (params.height || 550) + 'px', minHeight: (params.height || 550) + 'px', width: params.width || '100%', fontFamily: 'Open Sans' } }}
                muiTablePaperProps={{ sx: { border: 'none !important', boxShadow: 'none', width: '100%', backgroundColor: 'inherit' } }}
                onPaginationChange={(p) => {
                    setPagination(p)
                }}
                muiTableBodyRowProps={({ row }) => ({
                    onClick: () => {
                        setSelectedRowId((row.original as any).id);
                        params.onRowClick?.((row.original as any).id);
                        params.setSelectedRow?.((row.original as any));
                    },
                    sx: {
                        cursor: 'pointer',
                        backgroundColor: (selectedRowId == (row.original as any).id) ? `${ORANGE_COLOR} !important` : "auto",
                    },
                })}

            />
        </>
    );

}
